/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-06-25 18:10:36
 * @LastEditTime : 2023-12-18 11:34:10
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\reporSelfCheck.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/intelligent/selfreport/queryPageSelfReport";
/*导出报告*/
export const exportReport = "/icps/system/sign/intelligent/selfreport/exportReport";

//获取原物料管理数据
export function rawQueryPage(data) {
  return request({
    url: "icps/system/sign/basics/rawMaterials/QueryPage",
    method: "post",
    data,
  });
}
//设置28天
export function save28dSelfReport(data) {
  return request({
    url: "icps/system/sign/intelligent/selfreport/save28dSelfReport",
    method: "post",
    data,
  });
}
